// extracted by mini-css-extract-plugin
export default {"container":"custom_tooltip_container__+CbJ7"};